"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var ConfigContext_1 = __importDefault(require("./ConfigContext"));
var LocalizationConfig = /** @class */ (function (_super) {
    __extends(LocalizationConfig, _super);
    function LocalizationConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genContext = function () {
            var _a = _this.props, languageCode = _a.languageCode, disableAutoDetect = _a.disableAutoDetect, measurementUnits = _a.measurementUnits;
            return { languageCode: languageCode, disableAutoDetect: disableAutoDetect, measurementUnits: measurementUnits };
        };
        return _this;
    }
    LocalizationConfig.prototype.render = function () {
        return React.createElement(ConfigContext_1.default.Provider, { value: this.genContext() }, this.props.children);
    };
    return LocalizationConfig;
}(react_1.Component));
exports.default = LocalizationConfig;
